import { createSystem, defaultConfig, defineConfig } from '@chakra-ui/react';

const volyxConfig = defineConfig({
  theme: {
    tokens: {
      colors: {
        'volyx.primary': { value: '#1F2932' },
        'volyx.primaryLight': { value: '#E8F0FE' },
        'volyx.action': { value: '#007AFF' },
        'volyx.success': { value: '#34C759' },
        'volyx.warning': { value: '#FF9500' },
        'volyx.error': { value: '#FF3B30' },
        'volyx.secondary': { value: '#5856D6' },
        'volyx.text': { value: '#000000' },
        'volyx.textSecondary': { value: '#8E8E93' },
        // Body copy on white: textSecondary is ~3.3:1 there, this is ~5:1.
        'volyx.textMuted': { value: '#6C6C70' },
        'volyx.bg': { value: '#FFFFFF' },
        'volyx.lightGray': { value: '#F2F2F7' },
        'volyx.mediumGray': { value: '#C7C7CC' },
        'volyx.darkGray': { value: '#8E8E93' },
        'volyx.borderLight': { value: '#E1E5EB' },
        'volyx.darkBlue': { value: '#22314A' },
      },
      fonts: {
        body: { value: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif" },
        heading: { value: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif" },
      },
    },
  },
});

export const chakraSystem = createSystem(defaultConfig, volyxConfig);
